{
  "copySuccess": "คัดลอกแล้ว",
  "downloadSuccess": "ดาวน์โหลดแล้ว",
  "downloadFailed": "ไม่สามารถดาวน์โหลดได้",
  "serverError": "เกิดข้อผิดพลาดของเซิร์ฟเวอร์ โปรดลองอีกครั้งภายหลัง",
  "refresh": "รีเฟรช",
  "operationTimedOut": "การดำเนินการหมดเวลา โปรดลองอีกครั้ง",
  "noContent": "ยังไม่มีเนื้อหา",
  "returnHome": "กลับไปหน้าหลัก",
  "setTransactionPassword": "โปรดตั้งรหัสผ่านสำหรับการทำรายการก่อน",
  "setTransactionPasswordDescription": "โปรดตั้งรหัสผ่านสำหรับการทำรายการก่อนใช้วิธีทำรายการนี้ต่อ",
  "gotIt": "เข้าใจแล้ว",
  "goToSettings": "ไปที่การตั้งค่า",
  "securityVerification": "การยืนยันความปลอดภัย",
  "confirm": "ยืนยัน",
  "chooseFromLibrary": "เลือกจากอัลบั้ม",
  "takePhoto": "ถ่ายภาพ",
  "cancel": "ยกเลิก",
  "chooseAnotherVideo": "เลือกวิดีโออื่น",
  "startAppeal": "ยื่นอุทธรณ์",
  "amountMismatch": "จำนวนเงินไม่ตรงกัน",
  "complete": "เสร็จสิ้น",
  "invalidVideoFormat": "รูปแบบวิดีโอไม่ถูกต้อง",
  "videoTooLarge": "ขนาดวิดีโอเกินขีดจำกัด 200MB",
  "uploadVideoProof": "อัปโหลดหลักฐานวิดีโอ",
  "videoUploadHint": "วิดีโอที่อัปโหลดต้องไม่เกิน 200MB และรองรับ MP4, AVI, MOV",
  "currentLevel": "ระดับปัจจุบัน",
  "levelValidUntil": "ระดับมีผลถึง",
  "depositAddressLoadFailed": "ไม่สามารถรับที่อยู่ได้",
  "deposit": "รับเหรียญ",
  "depositNotice": "หมายเหตุสำคัญ",
  "depositNoticePrefix": "ที่อยู่นี้และคิวอาร์โค้ดรองรับเฉพาะการรับ",
  "depositNoticeSuffix": "การโอนผิดประเภทอาจกู้คืนไม่ได้และแพลตฟอร์มจะไม่ชดเชย โปรดยืนยันประเภทเหรียญที่ต้องการโอน",
  "allNotificationsRead": "ทำเครื่องหมายว่าอ่านแล้วทั้งหมด",
  "notifications": "การแจ้งเตือน",
  "markAllRead": "อ่านทั้งหมดแล้ว",
  "noNotifications": "ยังไม่มีการแจ้งเตือน",
  "settings": "การตั้งค่า",
  "language": "ภาษา",
  "pricingCurrency": "สกุลเงินอ้างอิง",
  "appNotifications": "การแจ้งเตือนของแอป",
  "devicePermissions": "สิทธิ์ของอุปกรณ์",
  "notificationPermissionDescription": "หากปิดใช้งาน คุณจะไม่ได้รับการอัปเดตคำสั่งซื้อและข้อความจากฝ่ายสนับสนุน",
  "enabled": "เปิดใช้งานแล้ว",
  "general": "ทั่วไป",
  "scanToPay": "สแกนเพื่อชำระเงิน",
  "unsupportedQrCode": "ไม่รองรับคิวอาร์โค้ดนี้",
  "scanQrCode": "สแกนคิวอาร์โค้ด",
  "scanQrFromLibrary": "สแกนคิวอาร์โค้ดจากอัลบั้ม",
  "qrCodeNotFound": "ไม่พบคิวอาร์โค้ด",
  "photoLibrary": "อัลบั้ม",
  "cameraUnavailable": "ไม่สามารถใช้กล้องได้",
  "cameraPermissionDescription": "ไม่ได้เปิดสิทธิ์กล้อง คุณเปลี่ยนได้ในการตั้งค่า",
  "invalidPaymentLink": "ลิงก์ชำระเงินไม่ถูกต้อง",
  "scanToPayHint": "ใช้เว็บแอป {{brand}} สแกนคิวอาร์โค้ดเพื่อชำระเงิน",
  "paymentQrExpired": "คิวอาร์โค้ดชำระเงินหมดอายุแล้ว",
  "signInToPayInBrowser": "เข้าสู่ระบบเพื่อชำระเงินในเบราว์เซอร์",
  "visitOfficialWebsite": "→ไปยังเว็บไซต์ทางการของ {{brand}}",
  "approximate": "≈ {{amount}}",
  "version": "เวอร์ชัน {{version}}",
  "buildCommit": "คอมมิตของบิลด์",
  "clearInput": "ล้างข้อมูลที่ป้อน",
  "showPassword": "แสดงรหัสผ่าน",
  "hidePassword": "ซ่อนรหัสผ่าน",
  "runtimeEnvironment": {
    "production": "ระบบใช้งานจริง",
    "staging": "ระบบทดสอบก่อนใช้งานจริง",
    "localhost": "การพัฒนาในเครื่อง"
  },
  "copying": "กำลังคัดลอก",
  "copyFailed": "คัดลอกไม่สำเร็จ",
  "copy": "คัดลอก",
  "backendEnvironment": "สภาพแวดล้อมแบ็กเอนด์",
  "environmentSwitchDescription": "การเปลี่ยนสภาพแวดล้อมจะล้างสถานะการเข้าสู่ระบบปัจจุบัน",
  "tradingDisabled": "ระบบอยู่ระหว่างบำรุงรักษา การซื้อขายถูกปิดชั่วคราว โปรดลองอีกครั้งภายหลัง",
  "diagnostics": {
    "cancelled": "ยกเลิกแล้ว",
    "preparing": "กำลังเตรียม",
    "exportFailed": "ส่งออกไม่สำเร็จ",
    "save": "บันทึก",
    "share": "แชร์",
    "saved": "บันทึกแล้ว",
    "shared": "เปิดการแชร์แล้ว",
    "title": "บันทึกการวินิจฉัย",
    "exportLog": "ส่งออกบันทึกการวินิจฉัย",
    "copyLog": "คัดลอกบันทึกการวินิจฉัย",
    "androidDescription": "คัดลอกบันทึกล่าสุดหรือบันทึกไฟล์ทั้งหมดได้",
    "iosDescription": "ส่งออกไฟล์และส่งให้ฝ่ายสนับสนุนของ {{brand}}"
  },
  "languageName": {
    "zh-Hans": "จีนตัวย่อ",
    "zh-Hant": "จีนตัวเต็ม",
    "th-TH": "ไทย",
    "vi-VN": "เวียดนาม"
  }
}
